module.exports = __webpack_public_path__ + "static/media/left-arrow-dark.0243541c.svg";